export default __webpack_public_path__ + "static/media/dynamic-allround-arc.124565f4.jpg";